module.exports = __webpack_public_path__ + "img/horizontal_3_2_8017.ae9677e5.png";